<p>home works!</p>
<div>
    <h1>Olá, meu nome é Gonzaga.</h1>
    <p>O poder da fotografia simples.</p>
  
    <h2>Tenho os seguintes serviços:</h2>
    <ul>
      <li>Fotografia</li>
      <li>Filmagem</li>
      <li>Edição</li>
      <li>Drone</li>
      <li>Eventos</li>
    </ul>
  </div>